module.exports = __webpack_public_path__ + "3361ee365a2503bfc4cc99244404c4f7.jpg";